module.exports = __webpack_public_path__ + "static/p3-0db963b77cbf7c0683e6939525f8f102.jpg";